import styled from 'styled-components'

import {ReactComponent as maintenanceSvg} from 'images/Maintenance/maintenance.svg'

export const MaintenanceContainer = styled.div`
  width: 100%;
  height: 100vh;
  text-align: center;
  background: #f7f7f7;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MaintenanceWrapper = styled.div`
  display: block;
  width: 700px;
  padding: 50px 70px;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #ffffff;

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    display: block;
    width: 95%;
    padding: 10px;
  }
`

export const MaintenanceSvg = styled(maintenanceSvg)`
  width: 75px;
  margin-top: 1em;
`

export const Title = styled.h1`
  font-size: 35px;
  text-align: center;
  font-family: ${({theme}) => theme.fontFamilies.default};

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    font-size: 20px;
  }
`

export const Content = styled.p`
  font-size: 18px;
  line-height: 30px;
  font-family: ${({theme}) => theme.fontFamilies.default};

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    font-size: 20px;
  }

  ${({theme}) => theme.breakpoints.down('tabletS')} {
    font-size: 16px;
  }
`

export const Team = styled.p`
  font-size: 35px;
  margin-top: 40px;
  font-family: ${({theme}) => theme.fontFamilies.default};

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    font-size: 40px;
  }
  ${({theme}) => theme.breakpoints.down('tabletS')} {
    font-size: 30px;
  }
`
